import { isProductionHost } from './environment';

/**
 * Which Chargebee site a page bills in: the live one in production, the test
 * one everywhere else, by the same host rule AddSalesPerson already follows.
 */

export const chargebeeSite = (host: string = window.location.host): string => (
  isProductionHost(host)
    ? 'https://pineapple.chargebee.com'
    : 'https://pineapple-test.chargebee.com'
);

export const chargebeeSubscriptionUrl = (id: string, host?: string): string => (
  `${chargebeeSite(host)}/d/subscriptions/${id}`
);

export const chargebeeCustomerUrl = (id: string, host?: string): string => (
  `${chargebeeSite(host)}/d/customers/${id}`
);
